import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/LandingViewWithImage";
import HowToPlay from "components/HowToPlay";
import BreakBar from "components/BarWithStats";
import BeforeFooter from "components/BeforeFooter";
import MiniCenteredFooter from "components/MiniCenteredFooter";

export default () => {

  return (<>
    <AnimationRevealPage>
      <Hero />
      <HowToPlay />
      <BreakBar />
      <BeforeFooter />
      <MiniCenteredFooter />
    </AnimationRevealPage>
  </>);
};